/**
 * A case (INV) as a list row: the badge, the title with its lines under it,
 * and the case number on the right. Triage's "next step is ours" lane and
 * Done's "Still open" built this row inline with ad-hoc styles while Done's
 * completed cases had a component of their own (kanban 445962e2). One row
 * for all three: same frame as the thread rows beside them.
 */
import type { ReactNode } from 'react';

import type { DoorInvestigationRead } from '../../services/qcpInvestigations';
import { primaryRef } from './caseIdentity';
import styles from './QualityTriagePages.module.css';

export default function CaseListRow({
  investigation,
  badge,
  onOpen,
  children,
  testId,
}: {
  investigation: DoorInvestigationRead;
  /** The word in the badge: CASE, OPEN. */
  badge: string;
  onOpen: (investigation: DoorInvestigationRead) => void;
  /** Lines under the title (checklist progress, who was asked…). */
  children?: ReactNode;
  testId?: string;
}) {
  return (
    <button
      type="button"
      className={styles.row}
      onClick={() => onOpen(investigation)}
      data-door-item={investigation.investigation_no}
      data-action="qcp_item_open"
      data-target-case-id={investigation.investigation_no}
      data-testid={testId}
    >
      <span className={`${styles.sev} ${styles.sev_watch}`}>{badge}</span>
      <span className={styles.rowBody}>
        <span className={styles.rowTitle}>{investigation.title}</span>
        {children}
      </span>
      <span className={styles.rowRight}>{primaryRef(null, investigation).label}</span>
    </button>
  );
}
